

<template>
  <!-- Choose Area Start -->
  <section class="best_pizza_area">
    <img src="../assets/img/choose_pizza.png" alt="shape" class="choose_pizza">
    <img src="../assets/img/shape_16.png" alt="shape" class="shape_16">
    <div class="container">
      <div class="row align-items-center justify-content-end">
        <div class="col-lg-7">
          <div class="choose_left">
            <h3 class="sub_title">Why Choose Us</h3>
            <h2 class="section_title">Pizzle is The Best Pizza <br> Restaurant in Town</h2>
            <img src="../assets/img/section_delimiter.png" alt="img" class="section_devider">
            <br>
            <br>
            <p>Piorem ipsum dolor sit amet consectetur adipiscing eliturabitur venenatis, nisl in bib endum commodo,
              sapien justo cursus are urna, quis porta mauris elit finibus nulla.</p>
            <ul class="choose_list">
              <li>
                <div class="choose_point">
                  <div class="choose_icon">
                    <img src="../assets/img/icon02.png" alt="img"/>
                  </div>
                  <div class="choose_text">
                    <h3>100% Halal Meat</h3>
                    <p>perspiciatis unde omnis iste<br> natus error sit vol</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="choose_point">
                  <div class="choose_icon">
                    <img src="../assets/img/icon03.png" alt="img"/>
                  </div>
                  <div class="choose_text">
                    <h3>Soft Crust</h3>
                    <p>perspiciatis unde omnis iste<br> natus error sit vol</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="choose_point">
                  <div class="choose_icon">
                    <img src="../assets/img/icon04.png" alt="img"/>
                  </div>
                  <div class="choose_text">
                    <h3>Crunchi French Fry</h3>
                    <p>perspiciatis unde omnis iste<br> natus error sit vol</p>
                  </div>
                </div>
              </li>
              <li>
                <div class="choose_point">
                  <div class="choose_icon">
                    <img src="../assets/img/icon01.png" alt="img"/>
                  </div>
                  <div class="choose_text">
                    <h3>Quality Chees</h3>
                    <p>perspiciatis unde omnis iste<br> natus error sit vol</p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Choose Area End -->
</template>
<script>
export default {
  name: 'ChooseArea'
}
</script>



// WEBPACK FOOTER //
// src/components/ChooseArea.vue